const LANGUAGE_STORAGE_KEY = 'zoofizjo_language';

export function readStoredLanguage(): string | null {
  return window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
}

export function storeLanguage(language: string): void {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}
